import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import useSettings from './State/Settings/useSettings';
import { Wrapper, Image, Placeholder, PlaceholderAction } from '../../StyledComponents/Map/wrapper';
import { ButtonSecondary, ButtonContent } from '../../StyledComponents/Button';
import { Position, Maybe } from '../../@types/codegen/types';

interface StaticMapProps {
  position?: Maybe<Position>;
}

const StaticMap = ({ position }: StaticMapProps) => {
  const { googleMapsApiKey, googleMapsMarker } = useSettings();
  const [visible, setVisible] = useState(false);

  const onShowMap = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (googleMapsApiKey) {
      e.preventDefault();
      setVisible(true);
    }
  }, []);

  if (!position) {
    return null;
  }

  const { latitude, longitude } = position;

  if (visible && googleMapsApiKey) {
    return (
      <Wrapper
        href={`https://maps.google.com/maps?q=${latitude},${longitude}`}
        title={i18next.t('item.showOnGoogleMaps') || ''}
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <Image
          src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=10&size=640x280&maptype=roadmap&markers=${
            googleMapsMarker ? `icon:${encodeURIComponent(googleMapsMarker)}` : ''
          }%7C${latitude},${longitude}&key=${googleMapsApiKey}`}
          alt={i18next.t('item.googleMapsMapAlt') || ''}
        />
      </Wrapper>
    );
  }
  return (
    <Placeholder
      href={`https://maps.google.com/maps?q=${latitude},${longitude}`}
      target="_blank"
      rel="noopener noreferrer nofollow"
      onClick={onShowMap}
    >
      <PlaceholderAction>
        <ButtonSecondary as="div">
          <ButtonContent>{i18next.t('item.googleMapsPlaceholderInit')}</ButtonContent>
        </ButtonSecondary>
      </PlaceholderAction>
    </Placeholder>
  );
};

export default StaticMap;
